import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablasComunesService from 'services/tablasComunes.service'

const TipoDetraccionFormGroup = ({
  iError,
  iTouched,
  fIsSubmitting,
  setFieldValue,
  handleChange
}) => {
  const [listaDetracciones, setListaDetracciones] = React.useState([])

  React.useEffect(() => {
    TablasComunesService.getAsSelect(TiposTablaComunConstant.DETRACCION).then(({ data }) => {
      setListaDetracciones(data)
    })
  }, [])

  const onChange = React.useCallback(
    e => {
      handleChange(e)

      const valorSeleccionado = e.target.value
      const elementoSeleccionado = listaDetracciones.find(x => x._id === valorSeleccionado)

      if (elementoSeleccionado) {
        setFieldValue('porcentaje', elementoSeleccionado.porcentaje)
      } else {
        setFieldValue('porcentaje', '')
      }
    },
    [setFieldValue, handleChange, listaDetracciones]
  )

  return (
    <Form.Group>
      <Form.Label text='TIPO' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='tipo'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-tipoDetraccion'
              isInvalid={iError && iTouched}
              disabled={fIsSubmitting}
              onChange={onChange}
            >
              <option value=''>Seleccionar</option>
              {listaDetracciones.map((x, k) => (
                <option key={k} value={x._id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iError && iTouched ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDetraccionFormGroup)
